import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Button,
  Stack,
  Typography,
  Slide,
  Box,
  useTheme,
  GlobalStyles,
  Divider
} from '@mui/material';
import {
  Update as UpdateIcon,
  AutoAwesome as AutoAwesomeIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { ThemeStyles } from '../../theme';
import { StrawberryIcon, IconNames } from '../icons';

const UpdateNotification = ({ open, onClose, onUpdate }) => {
  const [dismissed, setDismissed] = useState(false);
  const [showMinimized, setShowMinimized] = useState(false);
  const theme = useTheme();
  
  // Get centralized styles from theme engine
  const styles = ThemeStyles.updateNotification(theme);
  
  // Reset dismissed state when open changes
  useEffect(() => {
    if (open) {
      setDismissed(false);
      setShowMinimized(false);
    }
  }, [open]);
  
  // Handle the "Later" button click
  const handleLater = () => {
    setDismissed(true);
    setShowMinimized(true);
    onClose();
  };
  
  return (
    <>
      {/* Main notification with centralized styling */}
      <Snackbar
        open={open && !dismissed}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionComponent={Slide}
        sx={{
          zIndex: 1400,
          '& .MuiSnackbarContent-root': {
            minWidth: 'auto'
          }
        }}
      >
        <Box sx={styles.container}>
          {/* Header with icon and close button */}
          <Box sx={styles.header}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box>
                <Typography variant="h6" sx={styles.title}>
                  New Update Available
                  <AutoAwesomeIcon sx={{ fontSize: 18, ml: 0.5 }} />
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                  Update now to view the latest version
                </Typography>
              </Box>
            </Box>
            
            <Button
              onClick={handleLater}
              size="small"
              sx={styles.closeButton}
            >
              <CloseIcon fontSize="small" />
            </Button>
          </Box>

          <Divider sx={styles.divider} />

          {/* Action buttons */}
          <Box sx={styles.actionsContainer}>
            <Stack direction="row" spacing={1.5} justifyContent="center">
              <Button 
                variant="contained"
                size="medium"
                onClick={onUpdate}
                startIcon={<UpdateIcon />}
                sx={styles.primaryButton}
              >
                Update Now
              </Button>
            </Stack>
          </Box>
        </Box>
      </Snackbar>
      
      {/* Centralized minimized indicator */}
      {showMinimized && (
        <Box
          onClick={() => setDismissed(false)}
          sx={styles.minimizedIndicator}
        >
          <StrawberryIcon 
            name={IconNames.COPY}
            size={28}
            sx={{ 
              color: 'primary.main'
            }}
          />
        </Box>
      )}
      
      {/* Centralized animation styles */}
      <GlobalStyles styles={styles.animations} />
    </>
  );
};

export default UpdateNotification; 